'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useIsServerDriven } from '~/context/srp/SrpNavModeContext';

// TEMPORARY (REO-9372): tags RUM with the arm since turbo-boost isn't a real
// experiment yet. Remove once it's added to the experiments constant.
export default function useTurboBoostRumContext(): void {
  const isServerDriven = useIsServerDriven();

  useEffect(() => {
    datadogRum.setGlobalContextProperty(
      'srpTurboBoost',
      isServerDriven ? 'treatment' : 'control'
    );
  }, [isServerDriven]);
}
